import { format } from 'date-fns';

import { getPreferredTimeFormat } from '../../lib/utils/Convertor';

const is24HourFormat = () => getPreferredTimeFormat() === '24h';

export const formatDateTime = (date: Date | string) => {
  if (typeof date === 'string') {
    date = new Date(date);
  }

  return format(date, is24HourFormat() ? 'MMM do, HH:mm' : 'MMM do, h:mmaaa');
};

/**
 * Format the time-of-day part of a date following the user's preferred time format
 */
export const formatTimeOfDay = (date: Date | string) => {
  if (typeof date === 'string') {
    date = new Date(date);
  }

  return format(date, is24HourFormat() ? 'HH:mm' : 'h:mm a');
};

/**
 * Short date + time following the user's preferred time format
 */
export const formatDateAndTimeShort = (date: Date | string) => {
  if (typeof date === 'string') {
    date = new Date(date);
  }

  return format(date, is24HourFormat() ? 'dd MMM yyyy | HH:mm' : 'dd MMM yyyy | h:mm a');
};

/**
 * Transform a date in the year-month-day format to a date object
 * @param date
 */
export const dashToDate = (date: string): Date => {
  const [year, month, day] = date.split('-').map((value) => parseInt(value, 10));
  return new Date(year, month - 1, day);
};
